export const countDecimalDigits = (number) => {
  const charArray = number.toString().split('');
  const notDecimal = charArray.lastIndexOf('.');
  return notDecimal < 0 ? 0 : charArray.length - notDecimal - 1;
};
